module.exports = __webpack_public_path__ + "static/media/tallTree.947d8da9.png";